import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
  shortSummary_container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    margin: "20px 0px 40px 0px",
    gap: "20px",
  },

  title: {
    fontWeight: "bold",
    margin: "40px 0 20px 0",
    fontSize: "20px",
    letterSpacing: 0,
    lineHeight: "24px",
  },
  productsList: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    width: "100%",
  },
  see_more: {
    textDecoration: "underline",
    fontWeight: "bold",
    letterSpacing: 0,
    fontSize: "16px",
    cursor: "pointer",
    marginTop: "20px",
  },

  see_more_link: {
    cursor: "pointer",
    color: "#353535",
    letterSpacing: 0,
  },
}));

export default useStyles;
